import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { ServiceAccountList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { ServiceAccountCreateInitializer } from "./create/initializer";
import { ServiceAccountDetailInitializer } from "./detailInitializer";

const ServiceaccountRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<ServiceAccountList />} />
        <Route path={`-create/*`} element={<ServiceAccountCreateInitializer />} />
        <Route path={`:serviceaccount/*`} element={<ServiceAccountDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default ServiceaccountRoute;
